import { render, staticRenderFns } from "./UserDetailsPopup.vue?vue&type=template&id=6866a3d8&scoped=true&"
import script from "./UserDetailsPopup.vue?vue&type=script&lang=js&"
export * from "./UserDetailsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6866a3d8",
  null
  
)

export default component.exports